export default __webpack_public_path__ + "static/media/our-look.e0c9755b.png";